(function(a) {
  return (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
})(navigator.userAgent || navigator.vendor || window.opera);

$(document).ready(function() {
  var cart, frag, menu, _bind, product_template;
  menu = cart = false;
  
  Shopify.OptionSelectors.prototype.buildSelectors = function() {
  // build selectors
    for (var i = 0; i < this.product.optionNames().length; i++) {
      var sel = new Shopify.SingleOptionSelector(this, i, this.product.optionNames()[i], this.product.optionValues(i));
      sel.element.disabled = false;
      this.selectors.push(sel);
    }
  
    // replace existing selector with new selectors, new hidden input field, new hidden messageElement
    var divClass = this.selectorDivClass;
    var optionNames = this.product.optionNames();
    var elements = Shopify.map(this.selectors, function(selector) {
      var div = document.createElement('div');
      div.setAttribute('class', 'form-group');
      // create label if more than 1 option (ie: more than one drop down)
      if (optionNames.length > 1) {
        // create and appened a label into div
        var label = document.createElement('label');
        label.htmlFor = selector.element.id;
        isObject = function(obj) {
          return obj === Object(obj);
        };
  
        if(isObject(selector.name))
        {
          label.innerHTML = selector.name.name;
        }
        else
        {
          label.innerHTML = selector.name;
        }
        div.appendChild(label);
      } 
      div.appendChild(selector.element);
      return div;
    });
  
    return elements;
  };
  
  // MMenu setup

  $("#nav-menu").css({opacity: 1, visibility: 'visible'});
  $("#shopping-cart").css({opacity: 1, visibility: 'visible'});
  
  product_template = Handlebars.compile($("#product-template").html());
  
  $("#nav-menu").mmenu().on("opened.mm", function() {
    return menu = true;
  }).on("closed.mm", function() {
    return menu = false;
  });
  $("#shopping-cart").mmenu({
    'position': 'right'
  }).on("opened.mm", function() {
    return cart = true;
  }).on("closed.mm", function() {
    return cart = false;
  });

  // Toggle helper function
  $('[data-toggle]').click(function(e) {
    var arg, i, _i, _ref, _results;
    arg = $(this).data('toggle').split('/');

    if (arg[0][0] === 'x')
      $(".sub-nav").each(function() {
        if (!$(this).hasClass(arg[0])) {
          $(this).removeClass("show");
        }
      });

    for (i = _i = 0, _ref = arg.length - 1; _i <= _ref; i = _i += 2) {
      $("." + arg[i]).toggleClass("" + arg[i + 1]);
    }

    e.preventDefault();
  });

  $('.scrollup').click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 600);
    return false;
  });

  $('.find').click(function() {
    return $("#search-form").submit();
  });

  $.fn.transition = function() {
    return this.click(function(event) {
      var _href;
      event.preventDefault();
      _href = this.href;
      return $("body").fadeOut(500, function() {
        return window.location = _href;
      });
    });
  };

  $(".transition").transition();

  // Handlebars helper functions

  Handlebars.registerHelper('lt', function(arg, arg2, options) {
    if (arg <= arg2) {
      return options.fn(this);
    } else {
      return options.inverse(this);
    }
  });
  
  Handlebars.registerHelper('pluralize', function(arg) {
    if (arg > 1) {
      return "items";
    } else {
      return "item";
    }
  });
  
  Handlebars.registerHelper('money', function(arg) {
    return new Handlebars.SafeString(Shopify.formatMoney(arg, m_format));
  });
  
  Handlebars.registerHelper('empty', function(arg) {
    if (arg > 0) {
      return '';
    } else {
      return new Handlebars.SafeString("<li>There are no items in your cart.</li>");
    }
  });
  
  // Cart remove
  
  $(document).on('click', "[data-remove]", function() {
    var _id = $(this).data('variant-id');

    $.ajax(
      {
        type: 'POST',
        url: '/cart/change.js',
        data:  'quantity=0&id='+_id,
        dataType: 'json'
      }
    )
    .done(function(cart){
      $(document).trigger('ultron/notify', "Item has been removed from your cart");
      $(document).trigger('ultron/set-cart', cart);
    })
    .error(function(){
      $(document).trigger('ultron/notify', "Something's gone wrong. Try again.");
    });
  });

  // Modal
  
  $("[data-show-modal]").click(function(event) {
    var handle;
    handle = $(this).data('show-modal');
    $.ajax({
      url: "/products/" + handle + ".js",
      dataType: 'json',
      type: 'GET'
    }).done(function(product) {
      $("#modal-wrap").html(product_template(product));
      
      $(document).trigger('ultron/select');
      
      $("#product-modal").modal({backdrop: true});
      
      modal_flex = $(document).find("#product-modal-flex");
      modal_flex.owlCarousel({
        singleItem: true,
        autoPlay: 15000,
        autoHeight: true,
        slideSpeed: 350,
        transitionStyle : "fade"
      });
      
      var trig = false;
      
      $("[data-modal-flex]").click(function() {
        modal_flex.trigger('owl.goTo', $(this).data("modal-flex"));
      });
      
      var selectCallback = function(variant, selector) {
        if (variant) {
          if (variant.available) {
            $(".add-modal").removeClass("hidden");
            $(".soldout-modal").addClass("hidden");
            
          } else {
            $(".add-modal").addClass("hidden");
            $(".soldout-modal").removeClass("hidden");                     
          }
          // Whether the variant is in stock or not, we can update the price and compare at price.
          if ( variant.compare_at_price > variant.price ) {
            $('.price-modal').html('<h1>'+ Shopify.formatMoney(variant.price, m_format) +'<span class="old-price">'+Shopify.formatMoney(variant.compare_at_price, m_format)+ '</span></h1>');
          } else {
            $('.price-modal').html('<h1>'+ Shopify.formatMoney(variant.price, m_format) + '</h1>' );
          }        
        }
        
        $(document).trigger('ultron/select');
      }
      // initialize multi selector for product
      jQuery(function($) {
        new Shopify.OptionSelectors("product-select-modal", { 'product':  product, onVariantSelected: selectCallback });
      });
  
      $(document).on('click', "[data-close]", function() {
        $("#product-modal").modal("hide");
      });
    });
  
    event.preventDefault();
  });
  
  $(".notification").click(function() {
    $(this).removeClass("show");
  });
  
  var timeout;  
  $(document).on('ultron/notify', function(e, msg)
  {
    var _notify = $(".notification");
    clearTimeout(timeout);
    _notify.children("p").html(msg);
    _notify.addClass("show");
    
    timeout = setTimeout(function(){
      $(".notification").removeClass("show");
    }, 3000);
  });
  
  $(document).on('ultron/set-cart', function(e, cart) {
    var _template;
    _template = Handlebars.compile($("#cart-template").html());
    
    if(cart && cart === Object(cart))
    {
      $(".item-count").html(cart.item_count);
      return $(".cart-wrap").html(_template(cart));
    }
    else
    {
      return $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json'
      })
      .done(function(cart) {
        $(".item-count").html(cart.item_count);
        return $(".cart-wrap").html(_template(cart));
      });
    }
  });
  
  $(document).on('submit', "form#product-form", function(e) {
  var _sub = $(this).find(":submit");
    _sub.addClass('loading').html("Please wait ..");
    
    $.ajax(
      {
        url: '/cart/add.js', 
        data: $(this).serialize(),
        type: 'POST',
        dataType: 'json'
      }
    )
    .done(function( j_data ) {
      $(document).trigger('ultron/set-cart');
      $(document).trigger('ultron/notify', "Your item has been added to cart");      
    })
    .error(function( e_data ) {
      console.log(e_data);
      $(document).trigger('ultron/notify', "Sorry, something went wrong");
    })
    .always(function() {
      setTimeout(function() {
        $(".cart_checkout").fadeIn();
        _sub.removeClass('loading').html("Add to cart");
      }, 500);  
    });
    
    e.preventDefault();
  });
                                                                                                                                                                             
                                                                                                                                                                             
var pseudo_template, select_template;
select_template = "<div class=\"pseudo-select\" data-target=\"{{target}}\">\n	<div class=\"selected\">\n		<span class=\"pseudo-val\">{{selected}}</span>\n		<span class=\"icon-menu\"></span>\n	</div>\n	<ul>\n		{{#each options}}\n			<li data-pseudo-option=\"{{value}}\">{{option}}</li>\n		{{/each}}\n	</ul>\n</div>";
pseudo_template = Handlebars.compile(select_template);
$(document).on('ultron/select', function() {
  $(".pseudo-select").remove();
  var _frag, pseudo_target;
  pseudo_target = 0;
  $("select").each(function() {
    if(!$(this).data('no-pseudo'))
    {
    var data;
    data = {
      target: "pseudotarget" + pseudo_target,
      options: []
    };
    $(this).attr('data-pseudo-select', data.target);
    $(this).children('option').each(function() {
      return data.options.push({
        value: $(this).val(),
        option: $(this).text()
      });
    });
    data['selected'] = $(this).find(':selected').text();
    $(this).after(pseudo_template(data));

    pseudo_target += 1;
    return $(this).hide();
    }
  });
  $(".pseudo-select").unbind('click');
  $('.pseudo-select').click(function() {
    var _ps = this;
    $(".pseudo-select").each(function() {
      if($(_ps) !== $(this))
      	$(this).children('ul').removeClass('show');
    });
    $(this).children('ul').toggleClass('show');
  });
  $(document).on('click', '[data-pseudo-option]', function() {
    var parent, target;
    parent = $(this).parent().parent();
    target = parent.data('target');
    $("[data-pseudo-select='" + target + "']").val($(this).data('pseudo-option')).change();
    $(parent).children('.selected').children('.pseudo-val').html($(this).html());
    $(parent).children('ul').removeClass('show');
  });
  _frag = function(e) {
    var pseudoSelect;
    pseudoSelect = $(".pseudo-select");
    if (!pseudoSelect.is(e.target) && pseudoSelect.has(e.target).length === 0) {
      $(pseudoSelect).children('ul').removeClass('show');
    }
  };
  $(document).mousedown(function(e) {
    return _frag(e);
  });
  return $(document).bind("touchend", function(e) {
    return _frag(e);
  });
});


	
  $(document).trigger('ultron/select');                                                                                                                                                                       
  
  // Keyboard shortcuts 
  
  _bind = function(key, fn, context) {
    if (context == null) {
      context = document;
    }
    return $(context).bind('keydown keypress', key, fn);
  };
  _bind('c', function() {
    if (!menu) {
      if (!cart) {
        return $("#shopping-cart").trigger('open');
      } else {
        return $("#shopping-cart").trigger('close');
      }
    }
  });
  _bind('m', function() {
    if (!cart) {
      if (!menu) {
        return $("#nav-menu").trigger('open');
      } else {
        return $("#nav-menu").trigger('close');
      }
    }
  });
  _bind('Esc', function() {
    $("#shopping-cart").trigger('close');
    $("#nav-menu").trigger('close');
    $("#product-modal").modal('hide');
    $(".sub-nav").removeClass('show');
    $("#image-modal").modal("hide");
    
    $(document).trigger('ultron/hide-slideshow');
    return menu = cart = false;
  });
  frag = function(e) {
    var custom_select, sub_nav;
    custom_select = $(".filter");
    if (!custom_select.is(e.target) && custom_select.has(e.target).length === 0) {
      $(custom_select).children('ul').slideUp("fast");
      $(custom_select).children(".title").children(".arrow").removeClass("rotate");
    }
    
    sub_nav = $(document).find(".sub-nav, nav");
    if (!sub_nav.is(e.target) && sub_nav.has(e.target).length === 0) {
      $(sub_nav).removeClass("show");
    }
  };
  $(document).mousedown(function(e) {
    return frag(e);
  });
  return $(document).bind("touchend", function(e) {
    return frag(e);
  });
});